import { AxiosResponse } from 'axios';
import { AnunciosData, GetVoidAnunciosData } from '../types/Anuncio/AnuncioData';
import { PaginateObj } from '../types/Paginate/PaginateObjt';
import apiInterceptor from '../utils/axios';
import { AnuncioInteraccion, GetVoidAnuncioInteraccion } from '../types/Interacciones/AnuncioInteraccion';
import { GenericResponseData } from '../types/Response/GenericResponse';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIRECEPTOR = 'api/Catalog/receptor/';

export default class ReceptorService {

    static async GetAnuncios(categoria?: number): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}?categoria=${categoria}`);
        return response1.data;
    }

    static async GetAnunciosByTitle(name: string): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}search/${name}`);
        return response1.data;
    }

    static async GetAnunciosByKeyWord(key: string,categoria?: number): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}searchByKey/${key}?categoria=${categoria}`);
        return response1.data;
    }

    static async GetAnunciosPorVencer(categoria?: number): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}porvencer/?categoria=${categoria}`);
        return response1.data;
    }

    static async GetAnunciosPorVencerByTitle(name: string): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}porvencer/search/${name}`);
        return response1.data;
    }

    static async GetAnunciosPorVencerByKeyWork(name: string, categoria?: number): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}porvencer/ByKeyWork/${name}?categoria=${categoria}`);
        return response1.data;
    }

    static async GetAnuncio(id: number): Promise<GenericResponseData<AnunciosData>> {
        try {
            const response: AxiosResponse<AnunciosData> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}${id}`);    
            if (response.status === 200) {
                return {
                    status: response.status,
                    message: 'Operación completada con éxito',
                    data: response.data
                };
            } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                    status: response.status,
                    message: `Error: Código de estado ${response.status}`,
                    data: GetVoidAnunciosData(),
                };
            }
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return {
                status: 500,
                message: 'Error al realizar la solicitud',
                data: GetVoidAnunciosData()
            };
        }
    }

    static async GetAnunciosInteraccion(id: number): Promise<GenericResponseData<AnuncioInteraccion>> {
        try {
            const response: AxiosResponse<AnuncioInteraccion> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}log/${id}`);  
            if (response.status === 200) {
                return {
                    status: response.status,
                    message: 'Operación completada con éxito',
                    data: response.data
                };
            } else {
                console.error('Respuesta no exitosa:', response.status);
                return {
                    status: response.status,
                    message: `Error: Código de estado ${response.status}`,
                    data: GetVoidAnuncioInteraccion()
                };
            }  
        } catch (error) {
            console.error('Error al realizar la solicitud:', error);
            return {
                status: 500,
                message: 'Error al realizar la solicitud',
                data: GetVoidAnuncioInteraccion()
            };
        }        
    }

    static async GetPage(link: string): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${link}`);
        return response1.data;
    }

    static async GetHistorial(): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}historial/`);
        // console.log(`${SERV_BACK}${APIRECEPTOR}historial/`);
        return response1.data;
    }

    static async GetHistorialByName(name: string): Promise<PaginateObj<AnunciosData>> {
        const response1: AxiosResponse<PaginateObj<AnunciosData>> = await apiInterceptor.get(`${SERV_BACK}${APIRECEPTOR}historial/search/${name}`);
        // console.log(`${SERV_BACK}${APIRECEPTOR}historial/`);
        return response1.data;
    }
}